import { Formik, FormikActions, FormikProps } from 'formik';
import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SelectAsync, SelectNoneAsync } from '../../components/input/select/main';
import Paginate from '../../components/table/paginate';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import Input from '../../components/input/text/input-formik';
import { DatetimeFormik } from '../../components/input/date-time/date-time-formik';
import * as Actions from '../../store/actions/question';
import { Confirm, Notification } from '../../components/notification/main';
import { IQuestions, IFilter, IFilterFormik } from '../../models/components/questions';
import { QuestionType } from '../../models/enums/QuestionType';
import { IPagedQueryS } from '../../models/components/paginate';
import CAddExam from './addQuestion';
import { QuestionService } from '../../api/question-service';
import Loading from '../../components/loading/loading';
import ContentLoader from 'react-content-loader';
import BaseModal from '../../modal/base-modal/main';
import { IAddQuestionModalState, IQuestionBankProps } from '../../models/components/question-bank';
import { Common } from '../../core/common';
import imgAnn from '../../static/images/announcement.svg';
import Select from 'react-select';
import * as IFrameActions from '../../store/actions/iFrameSource';
import CustomIframeModal from '../../components/iframe/iframe-modal';
import * as BackGroundActions from '../../store/actions/background';
import ReactGA from 'react-ga4';
import AddMultipleQuestion from './addMultiQuestions';
import moment from 'moment';
import Tooltip from '../../components/tooltip/main';
import { Button } from '../../components/ui-elements/main';
import * as MadlenIntegrationActions from '../../store/actions/madlenIntegration';

const T = Translator.create();
const _logger = Log.create('Add Session Add Question');
const spinnerId = 'addQuestionLoadingMain';
const _questionService = new QuestionService();
let _common: Common;
let newFilterModel: IFilter = {
    keywordIds: '',
    categoryIds: '',
    masterCourseIds: '',
    courseIds: '',
    termIds: '',
    topicIds: '',
    examIds: '',
    questionCreateDate: null,
    questionUpdateDate: null,
    questionTypes: '',
    difficulties: '',
    questionText: ''
};

const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
];

const customStyles: any = {
    control: (styles: any) => ({
        ...styles,
        background: 'white',
        color: 'white',
        boxShadow: 'none',
        borderColor: '#ccc',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderRadius: 0
    }),
    menu: (styles: any) => ({
        ...styles,
        backgroundColor: 'white', // Menü arka planını beyaz yapıyoruz
        zIndex: 1000 // Menü için z-index ayarlıyoruz
    })
};

export class QuestionBankMain extends Component<IQuestionBankProps, IAddQuestionModalState> {
    public state: IAddQuestionModalState = {
        filters: {
            page: 1,
            take: 10,
            total: 0
        },
        isAll: false,
        disAllowedQuestionIds: [],
        selectedQuestionIds: [],
        filterInitialValues: {
            keywordIds: [],
            categoryIds: [],
            topicIds: [],
            masterCourseIds: [],
            courseIds: [],
            termIds: [],
            questionCreateDate: '',
            questionUpdateDate: ''
        },
        selectedOption: [{ value: 10, label: '10' }],
        isSelected: false,
        detailSearch: false,
        isAddModalOpen: false,
        isMultiAddModalOpen: false,
        updateQuestionId: '',
        isPreviewModalOpen: false,
        resultHtml: <div />,
        selectedQuestionId: '',
        isCustomIframeModalOpen: false,
        reset: false,
        isFromMadlen: false
    };

    constructor(props: IQuestionBankProps) {
        super(props);
        _common = new Common();
        this.onSubmit.bind(this);
    }

    componentDidMount() {
        let model = {
            ReturnUrl: '/Question/AddMultiple'
        };
        this.props.dispatch(IFrameActions.getIFrameSource(model));

        this.props.dispatch(Actions.getQuestionDifficulties());

        if (this.props.displayContentSyncPage) {
            this.props.dispatch(MadlenIntegrationActions.GetMadlenUrl("getMadlenUrl", 'get'));
        }
    }

    componentDidUpdate(prevProps: Readonly<IQuestionBankProps>, prevState: Readonly<IAddQuestionModalState>, snapshot?: any): void {
        if (
            prevProps.isDefaultUpdateQuestion &&
            this.props.isDefaultUpdateQuestion &&
            prevProps.isDefaultUpdateQuestion !== this.props.isDefaultUpdateQuestion
        ) {
            this.setState({
                isAll: false,
                selectedQuestionIds: [],
                disAllowedQuestionIds: [],
                filterInitialValues: {
                    keywordIds: [],
                    categoryIds: [],
                    topicIds: [],
                    masterCourseIds: [],
                    courseIds: [],
                    termIds: [],
                    questionCreateDate: '',
                    questionUpdateDate: ''
                }
            });
        }
        if (this.state.filterInitialValues !== prevState.filterInitialValues && this.state.filterInitialValues) {
            newFilterModel.questionText = this.state.filterInitialValues.questionText;
            newFilterModel.questionCreateDate = this.state.filterInitialValues.questionCreateDate
                ? moment(this.state.filterInitialValues.questionCreateDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                : null;
            newFilterModel.questionUpdateDate = this.state.filterInitialValues.questionUpdateDate
                ? moment(this.state.filterInitialValues.questionUpdateDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                : null;
            newFilterModel.difficulties = this.state.filterInitialValues.difficulties;
            newFilterModel.questionTypes = this.state.filterInitialValues.questionTypes;

            if (this.state.filterInitialValues.keywordIds && this.state.filterInitialValues.keywordIds.length > 0) {
                newFilterModel.keywordIds = this.state.filterInitialValues.keywordIds.toString();
            } else {
                newFilterModel.keywordIds = '';
            }
            if (this.state.filterInitialValues.categoryIds && this.state.filterInitialValues.categoryIds.length > 0) {
                newFilterModel.categoryIds = this.state.filterInitialValues.categoryIds.toString();
            } else {
                newFilterModel.categoryIds = '';
            }
            if (this.state.filterInitialValues.masterCourseIds && this.state.filterInitialValues.masterCourseIds.length > 0) {
                newFilterModel.masterCourseIds = this.state.filterInitialValues.masterCourseIds.toString();
            } else {
                newFilterModel.masterCourseIds = '';
            }
            if (this.state.filterInitialValues.courseIds && this.state.filterInitialValues.courseIds.length > 0) {
                newFilterModel.courseIds = this.state.filterInitialValues.courseIds.toString();
            } else {
                newFilterModel.courseIds = '';
            }
            if (this.state.filterInitialValues.termIds && this.state.filterInitialValues.termIds.length > 0) {
                newFilterModel.termIds = this.state.filterInitialValues.termIds.toString();
            } else {
                newFilterModel.termIds = '';
            }
            if (this.state.filterInitialValues.topicIds && this.state.filterInitialValues.topicIds.length > 0) {
                newFilterModel.topicIds = this.state.filterInitialValues.topicIds.toString();
            } else {
                newFilterModel.topicIds = '';
            }
            if (this.state.filterInitialValues.examIds && this.state.filterInitialValues.examIds.length > 0) {
                newFilterModel.examIds = this.state.filterInitialValues.examIds.toString();
            } else {
                newFilterModel.examIds = '';
            }
        }
    }

    onSubmit = async (model: IFilterFormik, FormActions: FormikActions<any>) => {
        if (model) {
            newFilterModel.questionText = model.questionText;
            newFilterModel.questionCreateDate = model.questionCreateDate
                ? moment(model.questionCreateDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                : null;
            newFilterModel.questionUpdateDate = model.questionUpdateDate
                ? moment(model.questionUpdateDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                : null;
            newFilterModel.difficulties = model.difficulties;
            newFilterModel.questionTypes = model.questionTypes;

            if (model.keywordIds && model.keywordIds.length > 0) {
                newFilterModel.keywordIds = model.keywordIds.toString();
            } else {
                newFilterModel.keywordIds = '';
            }
            if (model.categoryIds && model.categoryIds.length > 0) {
                newFilterModel.categoryIds = model.categoryIds.toString();
            } else {
                newFilterModel.categoryIds = '';
            }
            if (model.masterCourseIds && model.masterCourseIds.length > 0) {
                newFilterModel.masterCourseIds = model.masterCourseIds.toString();
            } else {
                newFilterModel.masterCourseIds = '';
            }
            if (model.courseIds && model.courseIds.length > 0) {
                newFilterModel.courseIds = model.courseIds.toString();
            } else {
                newFilterModel.courseIds = '';
            }
            if (model.termIds && model.termIds.length > 0) {
                newFilterModel.termIds = model.termIds.toString();
            } else {
                newFilterModel.termIds = '';
            }
            if (model.topicIds && model.topicIds.length > 0) {
                newFilterModel.topicIds = model.topicIds.toString();
            } else {
                newFilterModel.topicIds = '';
            }
            if (model.examIds && model.examIds.length > 0) {
                newFilterModel.examIds = model.examIds.toString();
            } else {
                newFilterModel.examIds = '';
            }
        }
        await this.getQuestion(newFilterModel, this.state.filters);
        this.setState({ filterInitialValues: model });
        FormActions.setSubmitting(false);
    };

    getQuestion = async (filters: IFilter, paging: IPagedQueryS) => {
        // filters.examSessionId = this.props.examSessionId;
        this.props.dispatch(Actions.GetQuestionList(filters, paging, 'getQuestions', 'get'));
    };

    printDiv(divContent: any) {
        const iframe = (document as any).frames ? (document as any).frames['idframe'] : (document as any).getElementById('idframe');
        const iframeWindow = iframe.contentWindow || iframe;

        iframe.focus();
        iframeWindow.print();

        return false;
    }

    public onChangeTake = (event: any) => {
        this.state.selectedOption = event;
        this.setState({ selectedOption: event });
        this.state.filters.take = event.value;
        this.setState(this.state);
        this.getQuestion(newFilterModel, this.state.filters);
    };

    validateAndSubmit = async (formik: FormikProps<any>) => {
        let isCompleted: boolean = true;

        const validations = await formik.validateForm().then((result: any) => result);
        Object.keys(validations).forEach((validationKey: string) => {
            Notification.setNotification(
                'error',
                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                'topRight'
            );

            isCompleted = false;
        });
        if (isCompleted) {
            formik.submitForm();
            this.setState({ isSelected: true, selectedQuestionIds: [], disAllowedQuestionIds: [], isAll: false });
        }
        const searched = document.getElementById('searched');
        const unsearched = document.getElementById('unsearched');
        if (unsearched && searched) {
            unsearched.className = 'd-none';
            searched.className = 'd-block';
        }
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        await this.getQuestion(newFilterModel, this.state.filters);
        this.state.filters.page = 1;
    };

    onSelectQuestion = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedQuestionIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedQuestionIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedQuestionIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                this.setState({ disAllowedQuestionIds: disAllowedIds });
            }
        }
    };

    deleteSelectedQuestionConfirmClick = (questionId?: any, type?: number) => {
        if (this.props.isSimulate) {
            return;
        }
        Confirm.setConfirm(
            'normal',
            () => this.deleteSelectedQuestions(questionId, type),
            this.state.selectedQuestionIds && this.state.selectedQuestionIds.length > 1
                ? T.t('r_delete_questions_selected')
                : T.t('r_delete_question_selected'),
            null
        );
    };

    deleteSelectedQuestions = (questionId?: any, type?: number) => {
        if (this.state.selectedQuestionIds?.length || this.state.isAll || type == 1) {
            let deletedIds = [];
            if (type === 1) {
                deletedIds = [questionId];
            } else {
                deletedIds = this.state.selectedQuestionIds;
            }
            this.props.dispatch(
                Actions.DeleteQuestion(
                    newFilterModel,
                    this.state.isAll,
                    deletedIds,
                    this.addSelectedQuestionsCallBack,
                    this.state.disAllowedQuestionIds,
                    '',
                    'get'
                )
            );
        }
    };

    downloadSelectedQuestions = (filterModel: any) => {
        if ((this.state.selectedQuestionIds && this.state.selectedQuestionIds.length) || this.state.isAll) {
            this.props.dispatch(
                BackGroundActions.GetQuestionBankExcelDownload(
                    filterModel,
                    this.state.filters,
                    this.state.selectedQuestionIds,
                    this.state.isAll,
                    'getQuestionBankExcelDownload',
                    'get'
                )
            );
        }
    };

    addSelectedQuestionsCallBack = async () => {
        await this.getQuestion(newFilterModel, this.state.filters).then(() => {
            this.setState({
                selectedQuestionIds: [],
                disAllowedQuestionIds: [],
                isAll: false
            });
        });
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            this.setState({ isAll: event.target.checked });
            if (!event.target.checked) {
                this.setState({ disAllowedQuestionIds: [] });
            }
        }
    };

    getDetails = async () => {
        this.setState({ detailSearch: !this.state.detailSearch });
    };
    public setModalActivity = (type: string) => {
        if (type == 'single') {
            ReactGA.event({
                category: window.location.host,
                action: 'G_QUESTIONBANK_NEW_QUESTION_CLICKED',
                label: 'G_QUESTIONBANK_NEW_QUESTION_CLICKED',
                nonInteraction: true
            });
            this.setState({ isAddModalOpen: true });
        } else {
            this.setState({ isMultiAddModalOpen: true });
        }
    };

    public setCloseModal = () => {
        this.setState({ isAddModalOpen: false, updateQuestionId: '' });
        this.props.dispatch(Actions.setQuestionDataDefault());
    };

    public setCloseMultiModal = () => {
        this.setState({ isMultiAddModalOpen: false });
    };

    public onChangeSelectCondition(selectValue: any, formik: FormikProps<IFilter>) {
        if (selectValue) {
            formik.setFieldValue('questionTypes', selectValue.value);
        } else {
            formik.setFieldValue('questionTypes', '');
        }
    }

    public onEditQuestion = async (questionId: any) => {
        if (this.props.isSimulate) {
            return;
        }
        if (questionId || this.state.selectedQuestionId != '') {
            this.props.dispatch(
                Actions.editQuestionGetAction(questionId ? questionId : this.state.selectedQuestionId, this.callbackOnEdit)
            );
        }
    };

    callbackOnEdit = (value: any) => {
        this.setState({
            isAddModalOpen: true,
            updateQuestionId: value,
            isPreviewModalOpen: false
        });
    };

    triggerPreviewModal = async (questionId: any) => {
        const params: any = {
            questionIds: []
        };

        if (questionId === -1) {
            params.questionIds = this.state.selectedQuestionIds;
        } else {
            params.questionIds.push(questionId);
        }

        if (this.state.isAll && questionId === -1) {
            params.questionIds =
                this.props.QuestionDatas?.results
                    ?.filter((item: IQuestions) => !this.state.disAllowedQuestionIds.includes(item.questionId))
                    .map((item: IQuestions) => item.questionId) ?? [];
        }

        const request = await _questionService.RequestGetQuestionPreviewAsync(params).then((responseData: Response) => {
            return responseData;
        });
        const result = await request.json();
        this.setState({
            resultHtml: result,
            isPreviewModalOpen: true,
            selectedQuestionId: questionId
        });
    };

    previewModalClose = () => {
        this.setState({
            isPreviewModalOpen: false
        });
    };

    triggerToAlmsQuestionBank() {
        ReactGA.event({
            category: window.location.host,
            action: 'G_QUESTIONBANK_IMPORT_QUESTION_CLICKED',
            label: 'G_QUESTIONBANK_IMPORT_QUESTION_CLICKED',
            nonInteraction: true
        });
        this.setState({
            ...this.state,
            isCustomIframeModalOpen: !this.state.isCustomIframeModalOpen
        });
        // this.props.dispatch(Actions.redirectToAlmsQuestionBank('LoadingMain', 'get'));
    }

    triggerToAlmsQuestionBankClose = () => {
        this.setState({
            isCustomIframeModalOpen: false
        });
    };

    returnPrintButton() {
        return (
            <div>
                <h6 className="modal-title d-inline-flex align-items-center mx-3" id="exampleModalLabel">
                    {T.t('r_question_preview_icon')}
                </h6>
                <Button
                    button_type={'primary'}
                    text={T.t('r_print')}
                    size={'small'}
                    onClick={() => this.printDiv(this.state.resultHtml)}
                    iconPosition='left'
                    materialicon="print" />
            </div>
        );
    }

    updateResetState = (status: boolean) => {
        this.setState({ reset: status });
    }

    resetForm = (formik: any) => {
        formik.resetForm();
        formik.values.questionTypes = '';
        this.updateResetState(true);
        this.setState({
            reset: true,
            filterInitialValues: {
                ...this.state.filterInitialValues,
                masterCourseIds: [],
                courseIds: [],
                termIds: [],
                examIds: [],
                questionText: '',
                keywordIds: [],
                topicIds: [],
                categoryIds: [],
                questionTypes: [],
                difficulties: null,
                questionUpdateDate: null,
                questionCreateDate: null
            }
        });
    };

    syncWithMadlen = (questionId: string) => {
        const questionIds: string[] = [questionId];
        this.props.dispatch(BackGroundActions.SyncQuestionsWithMadlen(questionIds));
    }

    getQuestionsFromMadlen = () => {
        window.open(this.props.madlenUrl, '_blank', 'noopener,noreferrer');
    }

    public render() {
        const loadingSpaces = 40;

        return (
            <div className="questions">
                <div className="question-filter">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <h6 className="mb-3 mb-md-0 page-header">{T.t('r_gen_questionBank')}</h6>
                            </div>
                            <div className="col-md-8 text-md-right">
                                <div className="options d-inline-flex align-items-center gap-1">
                                    {this.props.displayContentSyncPage &&
                                        (
                                            <Button
                                                onClick={() => this.getQuestionsFromMadlen()}
                                                button_type='secondary'
                                                size='medium'
                                                text={T.t('r_button_get_questions_from_madlen')}
                                            />
                                        )
                                    }

                                    <Button
                                        onClick={() => this.setModalActivity('multi')}
                                        button_type='secondary'
                                        size='medium'
                                        iconPosition='left'
                                        materialicon='filter_9_plus'
                                        text={T.t('r_add_multiple_questions')} />

                                    <Button
                                        onClick={() => this.setModalActivity('single')}
                                        button_type='primary'
                                        size='medium'
                                        iconPosition='left'
                                        materialicon='add'
                                        text={T.t('r_gen_questionBank_newQuestion')} />


                                </div>
                            </div>
                        </div>

                        <Formik initialValues={this.state.filterInitialValues} onSubmit={this.onSubmit}>
                            {formik => {
                                return (
                                    <div className="filter-fields mt-4">
                                        <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
                                            <div className="row align-items-baseline">
                                                <div className="col-md-3 col-12">
                                                    <div className="k365-input date-picker">
                                                        <label className="input-label">{T.t('r_gen_questionBank_master_course')}</label>
                                                        <SelectAsync
                                                            className='k365-select'
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                SearchedText: '',
                                                                SelectedIds: formik.values.masterCourseIds,
                                                                Take: 5
                                                            }}
                                                            placeHolder={T.t('r_gen_questionBank_master_course')}
                                                            url={'api/question/getMasterCourses'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'masterCourseIds'}
                                                            value={formik.values.masterCourseIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.masterCourseIds}
                                                            touched={formik.touched.masterCourseIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                            isClearable={true}
                                                            reset={this.state.reset}
                                                            updateResetState={this.updateResetState}
                                                            isOnlyOneItemSetting={false}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-12">
                                                    <div className="k365-input date-picker">

                                                        <label className="input-label">{T.t('r_activity_type_Course')}</label>
                                                        <SelectAsync
                                                            isMulti={true} className='k365-select'
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', GetTypes: 'Course', Skip: 0, Take: 10 }}
                                                            placeHolder={T.t('r_activity_type_Course')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'courseIds'}
                                                            value={formik.values.courseIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.courseIds}
                                                            touched={formik.touched.courseIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                            isClearable={true}
                                                            reset={this.state.reset}
                                                            updateResetState={this.updateResetState}
                                                            isOnlyOneItemSetting={false}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-12">
                                                    <div className="k365-input date-picker">
                                                        <label className="input-label">{T.t('r_gen_questionBank_questionTerm')}</label>
                                                        <SelectAsync
                                                            isMulti={true} className='k365-select'
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', SelectedIds: formik.values.termIds, Take: 5 }}
                                                            placeHolder={T.t('r_gen_questionBank_questionTerm')}
                                                            url={'api/question/getTerms'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'termIds'}
                                                            value={formik.values.termIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.termIds}
                                                            touched={formik.touched.termIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                            isClearable={true}
                                                            reset={this.state.reset}
                                                            updateResetState={this.updateResetState}
                                                            isOnlyOneItemSetting={false}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-12">
                                                    <div className="k365-input date-picker">
                                                        <label className="input-label">{T.t('r_activity_type_Exam')}</label>
                                                        <SelectAsync
                                                            isMulti={true} className='k365-select'
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                SearchedText: '',
                                                                SelectedIds: formik.values.examIds,
                                                                Take: 5
                                                            }}
                                                            placeHolder={T.t('r_activity_type_Exam')}
                                                            url={'api/question/getExams'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'examIds'}
                                                            value={formik.values.examIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.examIds}
                                                            touched={formik.touched.examIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                            isClearable={true}
                                                            reset={this.state.reset}
                                                            updateResetState={this.updateResetState}
                                                            isOnlyOneItemSetting={false}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12 mt-2">
                                                    <div className=" date-picker">
                                                        <Input
                                                            type={'text'}
                                                            name={'questionText'}
                                                            label={T.t('r_gen_questionBank_questionText')}
                                                            formik={formik}
                                                            reset={this.state.reset}
                                                            updateResetState={this.updateResetState}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                style={{ display: this.state.detailSearch ? '' : 'none' }}
                                                className="addvance-search pt-4"
                                            >
                                                <div className="row align-items-baseline">
                                                    <div className="col-md-3 col-12">
                                                        <div className="k365-input date-picker">
                                                            <label className="input-label">{T.t('r_gen_questionBank_questionKeyword')}</label>
                                                            <SelectAsync
                                                                isMulti={true} className='k365-select'
                                                                isSearchable={true}
                                                                requestType={'post'}
                                                                parameter={{
                                                                    SearchedText: '',
                                                                    SelectedIds: formik.values.keywordIds,
                                                                    Take: 5
                                                                }}
                                                                placeHolder={T.t('r_gen_questionBank_questionKeyword')}
                                                                url={'api/question/getKeyword'}
                                                                closeMenuOnScroll={false}
                                                                closeMenuOnSelect={false}
                                                                name={'keywordIds'}
                                                                value={formik.values.keywordIds}
                                                                onChange={formik.handleChange}
                                                                setFieldValue={formik.setFieldValue}
                                                                errors={formik.errors.keywordIds}
                                                                touched={formik.touched.keywordIds}
                                                                isTouched={formik.setFieldTouched}
                                                                hasLocalization={true}
                                                                setFieldOnlyValue={true}
                                                                isClearable={true}
                                                                reset={this.state.reset}
                                                                updateResetState={this.updateResetState}
                                                                isOnlyOneItemSetting={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 col-12">
                                                        <div className="k365-input date-picker">
                                                            <label className="input-label">{T.t('r_gen_questionBank_questionTopic')}</label>
                                                            <SelectAsync
                                                                className='k365-select'
                                                                isMulti={true}
                                                                isSearchable={true}
                                                                requestType={'post'}
                                                                parameter={{
                                                                    SearchedText: '',
                                                                    SelectedIds: formik.values.topicIds,
                                                                    Take: 5
                                                                }}
                                                                placeHolder={T.t('r_gen_questionBank_questionTopic')}
                                                                url={'api/question/getTopics'}
                                                                closeMenuOnScroll={false}
                                                                closeMenuOnSelect={false}
                                                                name={'topicIds'}
                                                                value={formik.values.topicIds}
                                                                onChange={formik.handleChange}
                                                                setFieldValue={formik.setFieldValue}
                                                                errors={formik.errors.topicIds}
                                                                touched={formik.touched.topicIds}
                                                                isTouched={formik.setFieldTouched}
                                                                hasLocalization={true}
                                                                setFieldOnlyValue={true}
                                                                isClearable={true}
                                                                reset={this.state.reset}
                                                                updateResetState={this.updateResetState}
                                                                isOnlyOneItemSetting={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 col-12">
                                                        <div className="k365-input date-picker">
                                                            <label className="input-label">{T.t('r_add_exam_category')}</label>
                                                            <SelectAsync
                                                                isMulti={true} className='k365-select'
                                                                isSearchable={true}
                                                                requestType={'post'}
                                                                parameter={{
                                                                    SearchedText: '',
                                                                    SelectedIds: formik.values.categoryIds,
                                                                    Take: 5
                                                                }}
                                                                placeHolder={T.t('r_add_exam_category')}
                                                                url={'api/question/getCategories'}
                                                                closeMenuOnScroll={false}
                                                                closeMenuOnSelect={false}
                                                                name={'categoryIds'}
                                                                value={formik.values.categoryIds}
                                                                onChange={formik.handleChange}
                                                                setFieldValue={formik.setFieldValue}
                                                                errors={formik.errors.categoryIds}
                                                                touched={formik.touched.categoryIds}
                                                                isTouched={formik.setFieldTouched}
                                                                hasLocalization={true}
                                                                setFieldOnlyValue={true}
                                                                isClearable={true}
                                                                reset={this.state.reset}
                                                                updateResetState={this.updateResetState}
                                                                isOnlyOneItemSetting={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 col-12">
                                                        <div className="k365-input date-picker">
                                                            <label className="input-label">{T.t('r_gen_questionBank_questionType')}</label>
                                                            <SelectNoneAsync
                                                                name={'questionTypes'} className='k365-select'
                                                                touched={formik.touched.questionTypes}
                                                                errors={formik.errors.questionTypes}
                                                                setFieldValue={formik.setFieldValue}
                                                                setOptions={[
                                                                    {
                                                                        value: 0,
                                                                        label: T.t('r_gen_questionBank_questionType_multiple_single')
                                                                    },
                                                                    {
                                                                        value: 3,
                                                                        label: T.t('r_gen_questionBank_questionType_multiple_multiple')
                                                                    },
                                                                    { value: 2, label: T.t('r_gen_questionBank_questionType_open') },
                                                                    { value: 4, label: T.t('r_gen_questionBank_questionType_ordering') },
                                                                    { value: 1, label: T.t('r_gen_questionBank_questionType_matching') }
                                                                ]}
                                                                onChange={formik.handleChange}
                                                                isTouched={formik.setFieldTouched}
                                                                placeHolder={T.t('r_gen_questionBank_questionType')}
                                                                isClearable={true}
                                                                reset={this.state.reset}
                                                                updateResetState={this.updateResetState}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row align-items-baseline pt-4">
                                                    <div className="col-md-3 col-12">
                                                        <div className="k365-input date-picker">
                                                            <label className="input-label">{T.t('r_gen_questionBank_dificulty')}</label>
                                                            <SelectAsync
                                                                isMulti={false} className='k365-select'
                                                                isSearchable={true}
                                                                requestType={'post'}
                                                                parameter={{ SearchedText: null, SelectedIds: null, Take: null }}
                                                                placeHolder={T.t('r_gen_questionBank_dificulty')}
                                                                url={'api/question/getDifficulties'}
                                                                closeMenuOnScroll={false}
                                                                closeMenuOnSelect={false}
                                                                name={'difficulties'}
                                                                value={formik.values.difficulties ? formik.values.difficulties : ''}
                                                                onChange={formik.handleChange}
                                                                setFieldValue={formik.setFieldValue}
                                                                errors={formik.errors.difficulties ? formik.values.difficulties : ''}
                                                                touched={formik.touched.difficulties ? formik.values.difficulties : ''}
                                                                isTouched={formik.setFieldTouched}
                                                                hasLocalization={true}
                                                                setFieldOnlyValue={true}
                                                                isClearable={true}
                                                                reset={this.state.reset}
                                                                updateResetState={this.updateResetState}
                                                                isOnlyOneItemSetting={false}
                                                            />
                                                        </div>
                                                        <div />
                                                    </div>
                                                    <div className="col k365-input">
                                                        <label className="input-label">{T.t('r_gen_questionBank_updatedDate')}</label>
                                                        <DatetimeFormik
                                                            name={'questionUpdateDate'}
                                                            formik={formik} className='k365-select'
                                                            datePickerId={'questionUpdateDate'}
                                                            placeHolder={T.t('r_gen_questionBank_updatedDate')}
                                                            mode="single"
                                                            time24Hr={true}
                                                            isClearable={true}
                                                            static={true}
                                                        />
                                                    </div>
                                                    <div className="col k365-input">
                                                        <label className="input-label">{T.t('r_gen_questionBank_createdDate')}</label>
                                                        <DatetimeFormik
                                                            name={'questionCreateDate'}
                                                            formik={formik}
                                                            datePickerId={'questionCreateDate'}
                                                            placeHolder={T.t('r_gen_questionBank_createdDate')}
                                                            mode="single"
                                                            time24Hr={true} className='k365-select'
                                                            isClearable={true}
                                                            static={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row pt-3">
                                                {this.state.isSelected ? (
                                                    <div className="col-md-3 col-12">
                                                        <div className=" d-flex flex-row">
                                                            <div className='k365-input'>
                                                                <label className='input-label'>{T.t('r_data_per_page')}</label>
                                                                <Select
                                                                    className='k365-select'
                                                                    options={options}
                                                                    value={this.state.selectedOption}
                                                                    onChange={this.onChangeTake}
                                                                    styles={customStyles}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                                <div className="col text-right" style={{ paddingBottom: 10 }}>
                                                    <div className="options d-inline-flex align-items-center gap-1">
                                                        <Button
                                                            onClick={() => this.resetForm(formik)}
                                                            button_type='primary'
                                                            size='medium'
                                                            disabled={formik.isSubmitting}
                                                            text={T.t('r_gen_clear')} />
                                                        <Button
                                                            onClick={() => this.validateAndSubmit(formik)}
                                                            button_type='primary'
                                                            size='medium'
                                                            iconPosition='left'
                                                            materialicon='search'
                                                            disabled={formik.isSubmitting}
                                                            text={T.t('r_gen_search')} />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                );
                            }}
                        </Formik>
                        <div className="text-right">
                            <button
                                onClick={this.getDetails}
                                data-toggle="modal"
                                data-target="#report-modal"
                                className="category-tag-square tag-gray"
                                style={{ marginInlineStart: '0.5 rem' }}
                            >
                                {T.t('r_gen_questionBank_advanceSearch')}{' '}
                                <i className="material-icons ml-2">{this.state.detailSearch ? 'arrow_upward' : 'arrow_downward'}</i>
                            </button>
                        </div>
                        <Loading spinnerId={'getQuestions'} height={'calc(100vh - 197px)'}>
                            <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                                <ContentLoader
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    style={{ width: '100%', height: '100%' }}
                                    preserveAspectRatio="xMinYMin meet"
                                >
                                    <rect x="22" y="24" rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 2} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 3} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 4} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 5} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 6} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 7} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 8} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 9} rx="3" ry="3" width="25" height="25" />
                                    <rect x="22" y={24 + loadingSpaces * 10} rx="3" ry="3" width="25" height="25" />

                                    <rect x="0" y="57" rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 2} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 3} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 4} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 5} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 6} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 7} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 8} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 9} rx="3" ry="3" width="100%" height="2" />
                                    <rect x="0" y={57 + loadingSpaces * 10} rx="3" ry="3" width="100%" height="2" />
                                </ContentLoader>
                            </div>
                        </Loading>

                        {this.props.QuestionDatas && this.props.QuestionDatas.results && this.props.QuestionDatas.results.length > 0 && (
                            <div className="justify-content-start no-hover question-row">
                                <div className="w-auto tick-radio position-relative">
                                    <input
                                        onChange={this.selectAll}
                                        type="checkbox"
                                        checked={this.state.disAllowedQuestionIds.length === 0 && this.state.isAll}
                                        name="demo"
                                        defaultValue="one"
                                        id="radio-three"
                                        className="form-radio"
                                        style={{ zIndex: 10 }}
                                    />
                                    <span style={{ color: '#abaaa7', paddingInlineStart: '6px' }}>{T.t('r_select_all')}</span>
                                </div>
                                {this.props.QuestionDatas &&
                                    this.props.QuestionDatas.results &&
                                    this.props.QuestionDatas.results.length > 0 &&
                                    ((this.state.selectedQuestionIds && this.state.selectedQuestionIds.length) || this.state.isAll) ? (
                                    <>
                                        <button
                                            className="category-tag-square tag-gray"
                                            style={{ marginInlineStart: '1rem' }}
                                            onClick={this.deleteSelectedQuestionConfirmClick}
                                        >
                                            <i className="material-icons mr-1">delete</i>
                                            {T.t('r_delete_selected_question')}
                                        </button>
                                        <button
                                            className="category-tag-square tag-gray"
                                            style={{ marginInlineStart: '1rem' }}
                                            onClick={() => this.downloadSelectedQuestions(newFilterModel)}
                                        >
                                            <i className="material-icons mr-1">archive</i>
                                            {T.t('r_question_archive')}
                                        </button>

                                        <button
                                            className="category-tag-square tag-gray"
                                            style={{ marginInlineStart: '1rem' }}
                                            onClick={() => this.triggerPreviewModal(-1)}
                                        >
                                            <i className="material-icons mr-1">visibility</i>
                                            {T.t('r_question_preview')}
                                        </button>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        )}

                        {this.state.isAddModalOpen ? (
                            <CAddExam
                                isModalOpen={this.state.isAddModalOpen}
                                setCloseModal={this.setCloseModal}
                                updateQuestionId={this.state.updateQuestionId}
                                isFromMadlen={this.state.isFromMadlen}
                            />
                        ) : (
                            ''
                        )}

                        {this.state.isMultiAddModalOpen && (
                            <AddMultipleQuestion
                                isModalOpen={this.state.isMultiAddModalOpen}
                                setCloseModal={this.setCloseMultiModal}
                                uploadMultiQuestionResult={this.props.uploadMultiQuestionData!}
                            />
                        )}

                        <div className="question-list mt-3" style={{ width: 'calc(100% + 28px)' }}>
                            {this.props.QuestionDatas && this.props.QuestionDatas.results && this.props.QuestionDatas.results.length ? (
                                this.props.QuestionDatas.results.map((item: IQuestions, index: any) => {
                                    return (
                                        <div key={'question-' + item.questionId} style={{ display: 'flex', marginBottom: '12px' }}>
                                            <div
                                                className=" question-row"
                                                style={{ overflow: 'inherit', float: 'left', width: 'calc(100% - 28px)' }}
                                            >
                                                <div className="col-7 pl-0 tick-radio position-relative">
                                                    {item.alreadyUsed ? (
                                                        <>
                                                            <Tooltip data={T.t('r_gen_exam_session_question_already_user')} position="top">
                                                                <i
                                                                    className="material-icons mr-2"
                                                                    style={{ width: 20, height: 20, fontSize: 20 }}
                                                                >
                                                                    info
                                                                </i>
                                                            </Tooltip>

                                                            <input className="form-radio" style={{ display: 'none' }} />
                                                        </>
                                                    ) : (
                                                        <input
                                                            data-id={item.questionId}
                                                            onChange={this.onSelectQuestion}
                                                            type="checkbox"
                                                            name="demo"
                                                            defaultValue="one"
                                                            id="radio-three"
                                                            checked={
                                                                (!this.state.isAll &&
                                                                    this.state.selectedQuestionIds.includes(item.questionId)) ||
                                                                (this.state.isAll &&
                                                                    !this.state.disAllowedQuestionIds.includes(item.questionId))
                                                            }
                                                            className="form-radio"
                                                            style={{ zIndex: 10 }}
                                                        />
                                                    )}

                                                    {/* tslint:disable-next-line:jsx-no-lambda */}
                                                    <label
                                                        onClick={() => this.triggerPreviewModal(item.questionId)}
                                                        className="text-truncate text-dark"
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.questionText.replace(/<\/?[^>]+(>|$)/g, '')
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-5 row-options">
                                                    <div
                                                        className="d-flex align-items-end justify-content-between"
                                                        style={{ minWidth: 204, width: 'inherit' }}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-start">
                                                            <Tooltip
                                                                data={T.t('r_question_type_' + QuestionType[item.questionType].toString())}
                                                                position="top"
                                                            >
                                                                <img
                                                                    src={_common.GetQuestionTypesIcons(
                                                                        QuestionType[item.questionType].toString() === 'MultipleMultiple'
                                                                            ? 'multiplemultiple'
                                                                            : QuestionType[item.questionType].toString() ===
                                                                                'MultipleSingle'
                                                                                ? 'multiplesingle'
                                                                                : QuestionType[item.questionType].toString() === 'Ordering'
                                                                                    ? 'ordering'
                                                                                    : QuestionType[item.questionType].toString() === 'OpenEnded'
                                                                                        ? 'openended'
                                                                                        : QuestionType[item.questionType].toString() === 'Matching'
                                                                                            ? 'matching'
                                                                                            : 'grouping'
                                                                    )}
                                                                    alt={'Question Type ' + QuestionType[item.questionType].toString()}
                                                                />
                                                            </Tooltip>

                                                            <span className="trueanswer">
                                                                {/* <a className="question-icon lead-tooltip mr-2">
                                                                    {"%" + item.successRate + "/" + item.correctCount}
                                                                    <div className="course-tooltip" style={{ lineHeight: '25px', zIndex: 1000, width: 'auto' }}>

                                                                        <ul className="tooltip-list w-100 mb-0">
                                                                            <li style={{ fontSize: '1em', textAlign: "start" }}>{T.t('r_gen_used_exam')}<span style={{ color: 'inherit', fontWeight: 'normal', float: "inline-end", minWidth: 'inherit' }}>{item.eCount}</span></li>
                                                                            <li style={{ fontSize: '1em', textAlign: "start" }}>{T.t('r_gen_true_answer')}<span style={{ color: 'inherit', fontWeight: 'normal', float: "inline-end", minWidth: 'inherit' }}>{item.correctCount}</span></li>
                                                                            <li style={{ fontSize: '1em', textAlign: "start" }}>{T.t('r_gen_true_percent')}<span style={{ color: 'inherit', fontWeight: 'normal', float: "inline-end", minWidth: 'inherit' }}>{item.successRate}</span></li>
                                                                        </ul>
                                                                    </div>
                                                                </a> */}
                                                                <Tooltip
                                                                    data={
                                                                        <ul className="tooltip-list w-100 mb-0">
                                                                            <li style={{ fontSize: '1em', textAlign: 'start' }}>
                                                                                {T.t('r_gen_used_exam')}
                                                                                <span
                                                                                    style={{
                                                                                        color: 'inherit',
                                                                                        fontWeight: 'normal',
                                                                                        minWidth: 'inherit'
                                                                                    }}
                                                                                >
                                                                                    {item.eCount}
                                                                                </span>
                                                                            </li>
                                                                            <li style={{ fontSize: '1em', textAlign: 'start' }}>
                                                                                {T.t('r_gen_true_answer')}
                                                                                <span
                                                                                    style={{
                                                                                        color: 'inherit',
                                                                                        fontWeight: 'normal',
                                                                                        minWidth: 'inherit'
                                                                                    }}
                                                                                >
                                                                                    {item.correctCount}
                                                                                </span>
                                                                            </li>
                                                                            <li style={{ fontSize: '1em', textAlign: 'start' }}>
                                                                                {T.t('r_gen_true_percent')}
                                                                                <span
                                                                                    style={{
                                                                                        color: 'inherit',
                                                                                        fontWeight: 'normal',
                                                                                        minWidth: 'inherit'
                                                                                    }}
                                                                                >
                                                                                    {item.successRate}
                                                                                </span>
                                                                            </li>
                                                                        </ul>
                                                                    }
                                                                    clickable
                                                                    position="top"
                                                                    delay={100}
                                                                >
                                                                    {'%' + item.successRate + '/' + item.correctCount}
                                                                </Tooltip>
                                                            </span>

                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div id="tags">
                                                                {item.difficulty && (
                                                                    <Tooltip
                                                                        data={T.t('r_gen_questionBank_dificulty')}
                                                                        position="top"
                                                                        delay={100}
                                                                    >
                                                                        <Button button_type={'secondary'} text={T.t('r_exam_difficulty_' + item.difficulty.replace(' ', ''))} size={'small'} />
                                                                    </Tooltip>
                                                                )}
                                                                {item.questionCategories && item.questionCategories !== ' ' && (
                                                                    <Button button_type={'secondary'}
                                                                        text={item.questionCategories.length > 12 ? item.questionCategories.substring(0, 12) + '...' : item.questionCategories}
                                                                        size={'small'} />
                                                                )}

                                                                {item.topics && item.topics !== ' ' && (
                                                                    <Button button_type={'secondary'} text={item.topics} size={'small'} />


                                                                )}
                                                            </div>

                                                            <div id="option_buttons">
                                                                {
                                                                    this.props.displayContentSyncPage && item.isFromMadlen && !item.alreadyUsed && (
                                                                        <div
                                                                            id="sync-button"
                                                                            style={{
                                                                                justifyContent: 'center',
                                                                                float: 'left',
                                                                                alignItems: 'center'
                                                                            }}
                                                                            onClick={() => this.syncWithMadlen(item.questionId)}
                                                                        >
                                                                            {!this.props.isSimulate && (
                                                                                <Tooltip data={T.t('r_button_sync_with_madlen')} position="top">
                                                                                    <i
                                                                                        className="material-icons"
                                                                                        style={{
                                                                                            marginLeft: '8px',
                                                                                            fontSize: '22px',
                                                                                            marginTop: '0px'
                                                                                        }}
                                                                                    >
                                                                                        sync
                                                                                    </i>
                                                                                </Tooltip>
                                                                            )}
                                                                        </div>
                                                                    )
                                                                }


                                                                <div
                                                                    id="edit-button"
                                                                    style={{
                                                                        justifyContent: 'center',
                                                                        float: 'left',
                                                                        alignItems: 'center',
                                                                        cursor: item.isFromMadlen ? 'not-allowed' : 'pointer'
                                                                    }}
                                                                    onClick={() => { this.setState({ isFromMadlen: item.isFromMadlen ?? false }); this.onEditQuestion(item.questionId) }}
                                                                >
                                                                    {!this.props.isSimulate && (
                                                                        <Tooltip data={T.t('r_question_edit_icon')} position="top">
                                                                            <i
                                                                                className="material-icons"
                                                                                style={{
                                                                                    marginLeft: '8px',
                                                                                    fontSize: '22px',
                                                                                    marginTop: '0px'
                                                                                }}
                                                                            >
                                                                                edit
                                                                            </i>
                                                                        </Tooltip>
                                                                    )}
                                                                </div>

                                                                <div
                                                                    id="preview-button"
                                                                    style={{
                                                                        justifyContent: 'center',
                                                                        float: 'left',
                                                                        alignItems: 'center'
                                                                    }}
                                                                    onClick={() => this.triggerPreviewModal(item.questionId)}
                                                                >
                                                                    <Tooltip data={T.t('r_question_preview_icon')} position="top">
                                                                        <i
                                                                            className="material-icons"
                                                                            style={{
                                                                                marginLeft: '8px',
                                                                                fontSize: '22px',
                                                                                marginTop: '-px'
                                                                            }}
                                                                        >
                                                                            visibility
                                                                        </i>
                                                                    </Tooltip>
                                                                </div>

                                                                <div
                                                                    id="delete-button"
                                                                    style={{
                                                                        justifyContent: 'center',
                                                                        float: 'left',
                                                                        alignItems: 'center'
                                                                    }}
                                                                    onMouseDown={event =>
                                                                        this.deleteSelectedQuestionConfirmClick(item.questionId, 1)
                                                                    }
                                                                >
                                                                    {!this.props.isSimulate && (
                                                                        <Tooltip data={T.t('r_delete_question')} position="top">
                                                                            <i
                                                                                className="material-icons"
                                                                                style={{
                                                                                    marginLeft: '8px',
                                                                                    fontSize: '22px',
                                                                                    marginTop: '-px'
                                                                                }}
                                                                            >
                                                                                delete
                                                                            </i>
                                                                        </Tooltip>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <>
                                    <img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} />

                                    <h5 id="searched" className="d-none" style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                        {T.t('r_gen_exam_session_question_not_found_criter')}
                                    </h5>
                                    <h5
                                        id="unsearched"
                                        className="d-block"
                                        style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}
                                    >
                                        {T.t('r_gen_exam_session_question_not_searched')}
                                    </h5>
                                </>
                            )}

                            {this.props.QuestionDatas && this.props.QuestionDatas.results && this.props.QuestionDatas.results.length > 0 && (
                                <div className="row-options justify-content-end">
                                    <div
                                        className="page-sorting d-flex align-items-center justify-content-center"
                                        style={{ marginTop: '5px' }}
                                    />
                                    <Paginate
                                        class={'custom-paginate'}
                                        filters={this.props.QuestionDatas.filters}
                                        onPageChange={this.onPageChange}
                                    />
                                </div>
                            )}
                        </div>
                        {this.state.isPreviewModalOpen ? (
                            <BaseModal
                                minWidth={850}
                                modalIsOpen={this.state.isPreviewModalOpen}
                                onClose={this.previewModalClose}
                                headerState={this.returnPrintButton()}
                                showHeader={true}
                                // tslint:disable-next-line:jsx-no-lambda
                                modalFooter={() => {
                                    let editResult = <></>;
                                    !this.state.isAll &&
                                        (editResult = (
                                            <div className="modal-footer d-flex justify-content-end">
                                                <Button
                                                    text={T.t('r_gen_edit')}
                                                    button_type={'primary'}
                                                    size={'large'}
                                                    onClick={() => this.onEditQuestion(this.state.selectedQuestionIds[0])}
                                                />
                                            </div>
                                        ));

                                    return editResult;
                                }}
                            >
                                <div style={{ minHeight: 'Calc(100vh - 250px)' }}>
                                    <iframe
                                        title="questionBankPreviewQuestion"
                                        id="idframe"
                                        name="idframe"
                                        style={{
                                            overflow: 'hidden',
                                            overflowX: 'hidden',
                                            overflowY: 'hidden',
                                            height: '100%',
                                            width: '100%',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            border: 0
                                        }}
                                        height="100%"
                                        width="100%"
                                        srcDoc={this.state.resultHtml}
                                    />
                                </div>
                            </BaseModal>
                        ) : null}
                        {this.state.isCustomIframeModalOpen ? (
                            <CustomIframeModal
                                onClose={this.triggerToAlmsQuestionBankClose}
                                id="QuestionBankIframe"
                                name="QuestionBankIframe"
                                modalName={T.t('r_menu_exam_statistics')}
                                src={this.props.iFrameSource}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IQuestionBankProps): IQuestionBankProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IQuestionBankProps = Object.assign({}, ownProps, {
        QuestionDatas: state.question.QuestionDatas,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        iFrameSource: state.iFrame.iFrameSource,
        // isDefaultUpdateQuestion: state.examSession.isDefaultUpdateQuestion
        uploadMultiQuestionData: state.question.UploadMultiQuestionResults,
        isSimulate: state.login.identitiy.isSimulate,
        displayContentSyncPage: state.login.login.displayContentSyncPage,
        madlenUrl: state.madlenIntegration.madlenUrl,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.question.QuestionDatas === prev.question.QuestionDatas &&
        next.question.UploadMultiQuestionResults === prev.question.UploadMultiQuestionResults &&
        next.madlenIntegration.madlenUrl === prev.madlenIntegration.madlenUrl
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CQuestinBankMain = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(QuestionBankMain);

export default CQuestinBankMain;
